









































































import Vue from 'vue';
import { DonationType, Type } from '@/classes/DonationType';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import i18n from '@/plugins/i18n';
import { DonationGuideVersion } from '@/enums/donationGuideVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
    mixins: [StepperFlowMixin],
    props: {
      donationTypes: {
        type: Array as () => Array<DonationType>
      },
      showBackButton: {
        type: Boolean,
        default: false
      },
      showNextButton: {
        type: Boolean,
        default: false
      },
      compact: Boolean,
    },
    computed: {
      steps(): typeof stepV1 | typeof stepV2 {
        return this.getDonationStepFlowVersion() == DonationGuideVersion.V1 ? stepV1 : stepV2;
      },
      donation() {
        return this.$store.state.donation
      },
      currentStep() {
        return this.$store.state.currentStep
      },
    },
    watch: {
      currentStep: {
        handler(newVal, oldVal) {
          if (newVal === this.steps.DONATION_TYPE) {
            if (this.donationTypes.length <= 1) {
              this.$emit('removeStep', this.steps.DONATION_TYPE)
              this.donationTypeClick(this.donationTypes[0])
            }
          }
        },
        immediate: true
      }
    },
    methods: {
      donationTypeClick(donationType: DonationType) {
        const currentGuideVersion: DonationGuideVersion = this.$store.state.donationGuideVersion;
        const requestGuideVersion: DonationGuideVersion = this.getDonationGuideVersionFromRequestSession(this.$store.state.requestSession)

        this.$store.commit('updateDonation', { donationType });
        // Contributions must stick to the old design for now. We will be able to remove this switching logic once Contribution has also been redesigned
        if (currentGuideVersion === DonationGuideVersion.V2 && donationType.type === Type.CONTRIBUTION) {
          this.handleDonationTypeVersionSwitch(donationType, DonationGuideVersion.V1);
        } else {
          // We need to handle the situation where the user first selected Contribution, but then went back and switched to donation/memorial gift
          if (currentGuideVersion === DonationGuideVersion.V1 && requestGuideVersion == DonationGuideVersion.V2 && donationType.type === Type.MEMORY_GIFT) {
            this.handleDonationTypeVersionSwitch(donationType, DonationGuideVersion.V2);
          } else {
            this.$emit('nextStep');
          }
        }
      },
      translateDonationTypeName(donationType: DonationType): string {
        return i18n.translateEntityName(donationType);
      },
      translateDonationTypeDescription(donationType: DonationType): string {
        return i18n.translateEntityDescription(donationType);
      },
    }
  });
